export default "__VITE_ASSET__DpTkkoHS__"